module.exports = __webpack_public_path__ + "img/satelite-diag.25ea5fd4.svg";